import * as React from "react"
import {DropdownItemProps, Form, Loader} from "semantic-ui-react"
import {BasicDriverFragment, BasicDrivers as BASIC_DRIVERS} from "../graphql/queries"
import {errorUnionToEither, handleError} from "../graphql/errors"
import {GraphQL} from "../graphql"

function driversOptions(
  driver: BasicDriverFragment | null,
  drivers: Array<BasicDriverFragment>,
): Array<DropdownItemProps> {
  const arr = drivers.map((driver) => ({
    text: driver.name,
    value: driver.id,
  }))

  // If the current driver is not null and not in the drivers list (which means it must be flagged
  // inactive), put it in the drop down as it remains a valid selection.
  if (driver !== null && !drivers.some((d) => d.id === driver.id)) {
    arr.unshift({text: driver.name, value: driver.id})
  }

  // A driver is always nullable
  arr.unshift({text: "None", value: ""})

  return arr
}

function DriverDropdown({
  driver,
  drivers,
  onDriver,
}: WithDriversProps & {drivers: Array<BasicDriverFragment>}) {
  return (
    <Form.Dropdown
      name="driver"
      placeholder="Driver"
      search={true}
      selection={true}
      selectOnNavigation={false}
      selectOnBlur={false}
      value={driver ? driver.id : ""}
      onChange={(e, data) => {
        // If the current driver is not active we won't find it below, so check explicitly first.
        if (driver && driver.id === data.value) {
          onDriver(driver)
        } else {
          onDriver(drivers.find((driver) => driver.id === data.value) || null)
        }
      }}
      options={driversOptions(driver, drivers)}
    />
  )
}

interface WithDriversProps {
  driver: BasicDriverFragment | null
  onDriver: (driver: BasicDriverFragment | null) => void
}

function WithDrivers(props: WithDriversProps) {
  return (
    <GraphQL.Query
      query={BASIC_DRIVERS}
      variables={{active: true}}
      // TODO This forced network request is here only because we don't have a first class way to
      // invalidate the driver queries after admin has added/updated a driver.  But only admin renders
      // this component and the query is only run when we are not readOnly, so it's a small price.
      fetchPolicy="cache-and-network"
      render={({data}) => {
        if (data) {
          return handleError(errorUnionToEither(data.drivers), (x) => (
            <DriverDropdown {...props} drivers={x.drivers} />
          ))
        } else {
          return <Loader inline active />
        }
      }}
    />
  )
}

interface DriverPickerProps {
  driver: BasicDriverFragment | null
  onDriver: ((driver: BasicDriverFragment | null) => void) | null
}

export function DriverPicker(props: DriverPickerProps) {
  const {driver, onDriver} = props
  return !onDriver ? (
    <div>{driver ? driver.name : <i>None</i>}</div>
  ) : (
    <WithDrivers driver={driver} onDriver={onDriver} />
  )
}

export function DriverPickerField(props: DriverPickerProps) {
  return (
    <Form.Field>
      <label>Driver</label>
      <DriverPicker {...props} />
    </Form.Field>
  )
}



// WEBPACK FOOTER //
// ./src/components/DriverPicker.tsx